// Shared shapes for the inline proofreader. Offsets are UTF-16 indices into
// a single textblock's plain text, exactly what `String.prototype.slice`
// uses, so they line up with the ProseMirror position map built in
// ProofreadExtension. Spans come from server/src/services/proofread.

export type ProofCategory =
  | "spelling"
  | "grammar"
  | "capitalization"
  | "repetition"
  | "punctuation"
  | "clarity";

export interface ProofSuggestion {
  /** `${blockHash}:${start}:${end}:${kind}` — stable for one lint run. */
  id: string;
  /** Hash of the textblock's plain text this suggestion was computed for. */
  blockHash: string;
  start: number;
  end: number;
  /** The exact text between start and end at lint time. */
  original: string;
  /** Optional explanation shown under the label; empty when none. */
  message: string;
  category: ProofCategory;
  /** Full replacement strings for [start, end). "" means delete. Max 3. */
  replacements: string[];
}

export const PROOF_CATEGORY_LABEL: Record<ProofCategory, string> = {
  spelling: "Fix spelling",
  grammar: "Correct grammar",
  capitalization: "Fix capitalization",
  repetition: "Remove repeated word",
  punctuation: "Fix punctuation",
  clarity: "Improve clarity",
};
